import styled from "styled-components"
import {greys} from "@irati/ui/src/global/colors"

export default styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    padding: 20px 0;
    &:not(:last-of-type) {
      border-bottom: 1px solid ${greys.disabled};
    }
`
